export default __webpack_public_path__ + "static/media/working01.060f1178.png";